import React from "react";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Logo from "../../components/Logo";
import feathers from "../../feathers";
import {FacilityRecord} from "../../feathers/records";
import SignupStepper from "../../components/Signup/Stepper";

import "./style.scss";

export default class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.signupService = feathers.service("auth/signup");
    this.signupAbandonService = feathers.service("auth/signup-abandon");
    this.state = {
      redirect: null,
      error: null,
      fetching: false,
      emailSent: false,
      data: {
        address: "",
        geo: [],
        first_name: "",
        last_name: "",
        account_name: "",
        email: "",
        password: ""
      }
    };

    this.sendAbandonEmail = this.sendAbandonEmail.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  async sendAbandonEmail() {
    const {data, emailSent} = this.state;
    if (data.email && !emailSent) {
      try {
        await this.signupAbandonService.create(data);
      } catch (err) {
        //intentionally empty
      }
    }
    this.setState({emailSent: true});
  }

  async redirectFirstFacility() {
    const newFacility = await FacilityRecord.find();
    const {_id: facilityId} = newFacility.data.toList().first();
    return `/map/${facilityId}?signup=true`;
  }

  getRewardfulReferral() {
    let rewardful_referral_id = null;
    let rewardful_referrer_token = null;
    if (window.Rewardful) {
      rewardful_referral_id = window.Rewardful.referral || null;
      rewardful_referrer_token = window.Rewardful.affiliate ? window.Rewardful.affiliate.token : null;
    }
    return {rewardful_referral_id, rewardful_referrer_token};
  }

  getSignupPayload({rewardful_referral_id, rewardful_referrer_token}) {
    return {
      plan: this.props.location.query.plan || "free",
      address: this.state.data.address,
      geo: {
        type: "Point",
        coordinates: this.state.data.geo
      },
      first_name: this.state.data.first_name,
      last_name: this.state.data.last_name,
      email: this.state.data.email,
      password: this.state.data.password,
      account_name: this.state.data.account_name,
      rewardful_referral_id,
      rewardful_referrer_token
    };
  }

  async handleSubmit(event) {
    try {
      event.preventDefault();

      this.setState({
        fetching: true,
        error: false
      });

      const rewardfulData = this.getRewardfulReferral();
      const signupPayload = this.getSignupPayload(rewardfulData);
      let {user} = await this.signupService.create(signupPayload);
      await feathers._authenticate({
        strategy: "local",
        email: user.email,
        password: signupPayload.password
      });
      let redirect = await this.redirectFirstFacility();
      this.props.onSuccess(redirect);
    } catch (err) {
      this.setState({
        error: err.message,
        fetching: false
      });
    }
  }

  handleChange({name, value}) {
    this.setState({
      data: {...this.state.data, [name]: value}
    });
  }

  render() {
    const {error, fetching, data} = this.state;
    return (
      <div className="unauthed-page">
        <div className="container-fluid">
          <div className="row middle-md middle-sm middle-xs">
            <div className="col-md-8 col-md-offset-2 col-sm-6 col-sm-offset-3 col-xs-12">
              <Paper className="unauthed-box">
                <div className="logo-container">
                  <div className="row">
                    <div className="col-sm-6">
                      <Logo width="200" />
                    </div>
                    <div className="col-sm-6">
                      <div style={{textAlign: "center"}}>
                        <h4 style={{paddingTop: 12, paddingBottom: 5}}>Free Trial of MapPlug</h4>
                        <H3>No credit card. Start in seconds.</H3>
                      </div>
                    </div>
                  </div>
                </div>
                <SignupStepper
                  data={data}
                  fetching={fetching}
                  onChange={this.handleChange}
                  onAbandon={this.sendAbandonEmail}
                  onSubmit={this.handleSubmit}
                />
              </Paper>
              {fetching && <LinearProgress mode="indeterminate" />}
              {error && <div className="unauthed-error">{error}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const H3 = ({children}) => <h3 className="colorBlue">{children}</h3>;



// WEBPACK FOOTER //
// ./src/pages/Signup/index.jsx